<template>
  <div>
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>疗养预约系统</el-breadcrumb-item>
        <el-breadcrumb-item>疗养信息</el-breadcrumb-item>
        <el-breadcrumb-item>疗养信息详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-table
        slot="content"
        :data="convalescenceDetail"
        max-height="800"
        border
      >
        <el-table-column prop="status" align="center" label="申请状态">
        </el-table-column>

        <el-table-column prop="" align="center" label="申请提交时间">
          <template slot-scope="scope">
            {{ scope.row.applyStartTime }}至{{ scope.row.applyEndTime }}
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" label="疗养时间">
          <template slot-scope="scope">
            {{ scope.row.recuperateStartTime }}至{{
              scope.row.recuperateEndTime
            }}
          </template>
        </el-table-column>

        <el-table-column prop="address" align="center" label="疗养地点">
        </el-table-column>

        <el-table-column>
          <template>
            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要关闭申请入口？"
              v-on:confirmed="closeApply()"
            >
              <span>关闭申请入口</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams">
        <el-row :gutter="24">
          <el-col :span="7">
            <el-form-item label="疗养时间：" prop="startTime">
              <el-date-picker
                size="small"
                v-model="listParams.startTime"
                style="float:left;width:150px;"
                value-format="timestamp"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="疗养地点：" prop="address">
              <el-select
                size="small"
                v-model="listParams.address"
                style="float:left;width:150px;"
              >
                <el-option
                  v-for="item in convalescenceAddressList"
                  :key="item"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="7">
            <el-form-item label="手机号：" prop="tel">
              <el-input
                v-model="listParams.tel"
                size="small"
                placeholder="请输入预定手机号"
                style="float:left;width:150px;"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-button size="small" @click="searchData" style="margin-top:4px;">
              查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" size="small" v-on:click="outExcel">
            导出
          </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column prop="recuperateTime" align="center" label="疗养时间">
        </el-table-column>

        <el-table-column prop="address" align="center" label="疗养地点">
        </el-table-column>

        <el-table-column prop="tel" align="center" label="申请人员">
        </el-table-column>

        <el-table-column prop="applyTime" align="center" label="申请提交时间">
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
import { download } from '../../../../utils/javascript/download';

export default {
  data() {
    return {
      listParams: {},
      convalescenceAddressList: [], // 疗养地点列表
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      convalescenceDetail: [
        {
          status: "",
          applyStartTime: "",
          applyEndTime: "",
          recuperateStartTime: "",
          recuperateEndTime: "",
          address: ""
        }
      ]
    };
  },
  mounted() {
    this.loadConvalescenceAddressList();
    this.loadConvalescenceDetail(this.$route.query.id);
    this.loadTableData(this.$route.query.id);
  },
  methods: {
    outExcel() {
      // this.formLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          startTime: this.listParams.startTime,
          addressId: this.listParams.address,
          tel: this.listParams.tel,
          recuperateId: this.$route.query.id
        }
      );

      download("/recuperate/applyExcel", bodyParams, "疗养信息详情");

      // this.$http({
      //   url: global.apiUrl + "/recuperate/applyExcel",
      //   method: "GET",
      //   params: bodyParams,
      //   emulateJSON: true,
      //   responseType: "arraybuffer"
      // })
      //   .then(res => {
      //     const blob = new Blob([res.data], {
      //       type: "application/vnd.ms-excel"
      //     });
      //     const url = URL.createObjectURL(blob);
      //     window.location.href = url;
      //   })
      //   .catch(err => {
      //     this.formLoading = false;
      //
      //     console.error(err);
      //   });
    },
    closeApply() {
      const id = this.$route.query.id;
      const bodyParams = Object.assign(
        {},
        {
          recuperateId: id
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/closeApply",
        method: "POST",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.$message.success(res.body.info);
            this.$router.push({
              name: "convalescenceInfo"
            });
          } else {
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    loadConvalescenceDetail(id) {
      this.formLoading = false;
      const bodyParams = Object.assign(
        {},
        {
          recuperateId: id
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/recuperateDetail",
        methods: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.convalescenceDetail[0].status = res.body.data.status;
            this.convalescenceDetail[0].applyStartTime =
              res.body.data.applyStartTime;
            this.convalescenceDetail[0].applyEndTime =
              res.body.data.applyEndTime;
            this.convalescenceDetail[0].recuperateStartTime =
              res.body.data.recuperateStartTime;
            this.convalescenceDetail[0].recuperateEndTime =
              res.body.data.recuperateEndTime;
            this.convalescenceDetail[0].address = res.body.data.address;
          } else {
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    loadConvalescenceAddressList() {
      this.formLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          page: 1,
          size: 100
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/address/list",
        methods: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.convalescenceAddressList = res.body.data.data;
          } else {
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    searchData() {
      this.formLoading = true;

      const bodyParams = Object.assign(
        {},
        {
          startTime: this.listParams.startTime,
          addressId: this.listParams.address,
          tel: this.listParams.tel,
          recuperateId: this.$route.query.id,
          page: this.pager.pageIndex,
          size: this.pager.pageSize
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/apply/list",
        methods: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.$message.success(res.body.info);
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableData = [];
            this.pager.total = 0;
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    loadTableData(id) {
      this.formLoading = true;
      const bodyParams = Object.assign(
        {},
        {
          startTime: "",
          addressId: "",
          tel: "",
          recuperateId: id,
          page: this.pager.pageIndex,
          size: this.pager.pageSize
        }
      );
      this.$http({
        url: global.apiUrl + "/recuperate/apply/list",
        methods: "GET",
        params: bodyParams
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableData = [];
            this.pager.total = 0;
            this.formLoading = false;

          }
        })
        .catch(err => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 重置表单
     * @param name
     */
    resetForm(name) {
      this.$refs[name].resetFields();
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>
<style>
#convalescenceInfoTable {
  border-collapse: collapse;
}
#convalescenceInfoTable {
  width: 100%;
}
#convalescenceInfoTable th {
  font-weight: normal;
  text-align: left;
  font-size: 14px;
}
#convalescenceInfoTable th:nth-child(1) {
  width: 12%;
}
#convalescenceInfoTable th:nth-child(2) {
  width: 12%;
}
#convalescenceInfoTable th:nth-child(3) {
  width: 12%;
}
#convalescenceInfoTable th:nth-child(4) {
  width: 52%;
}
#convalescenceInfoTable th:nth-child(5) {
  width: 12%;
}
#convalescenceInfoTable table,
thead th,
thead td {
  border-bottom: 1px solid #bbbbbb;
  padding: 10px 0 20px 0;
  text-align: center !important;
}
#convalescenceInfoTable tbody th,
tbody td {
  text-align: center;
  padding: 20px 0;
}
#convalescenceInfoTable td {
  font-size: 14px;
}
#convalescenceInfoTable td {
  padding-top: 20px;
}
</style>
